<template>
    <div class="container-fluid">
        <form class="row pl-3 py-3 font-weight-bold" @submit.prevent="confirmSaveCrewRecord">

            <div class="col-12 text-left p-0">
                <hr class="my-0"/>
                <div class="row bg-light-gray">
                    <div class="col col-sm-8">
                        <h6 class="h6 font-weight-bold mt-2" @click="test">General Information</h6>
                    </div>
                    <div class="col col-sm-4 text-right">
                        <button type="button"
                                class="btn btn-sm btn-xs btn-outline-success px-2 mr-1 font-weight-bolder mt-2"
                                @click="checkDuplicateCrew">
                          <i class="fas fa-user-check mr-1"></i>Check Duplicate Crew
                        </button>
                        <button class="btn btn-sm btn-xs btn-outline-primary px-2 mr-1 font-weight-bolder mt-2" title="Save Crew Record" type="submit">
                            <span class="fas fa-save"></span>
                            Save
                        </button>
                    </div>
                </div>
                <hr class="mt-0"/>


                <div class="row text-small">

                    <div class="col-md-2 pr-0">
                        <div class="crew-pic-container mx-auto">
                            <img :src="crewImage" alt="Crew Image"
                                 id="crewImage"
                                 class="img-thumbnail crew-pic" style="width: 100%; height: auto; cursor: pointer"
                                 @click="clickCrewImageInput"
                            >
                            <input type="file" class="d-none"
                                   accept="image/*"
                                   name="crewImageInput"
                                   id="crewImageInput"
                                   @change="updateImageDisplay"
                            >
                        </div>

                        <div class="row mb-2">
                            <label for="biodata" class="col-sm-4 text-right p-0 my-auto pr-2">Biodata: </label>
                            <input type="file" class="col-sm-8 form-control form-control-xs p-0" id="biodata" accept="application/pdf">
                        </div>

                        <div class="row">
                            <label for="consent" class="col-sm-4 text-right p-0 my-auto pr-2">Consent: </label>
                            <input type="file" class="col-sm-8 form-control form-control-xs p-0" id="consent" accept="application/pdf">
                        </div>

                    </div>

                    <div class="col-md-10">

                        <div class="row">

                            <div class="col col-4 pr-0">

                                <div class="form-group row" :class="{ 'has-error': newCrewErrors.last_name }">
                                    <label for="lastName" class="col-sm-4 col-form-label text-lg-right">Last Name</label>
                                    <div class="col-sm-7 text-center">
                                        <input type="text" class="form-control form-control-xs" required
                                               id="lastName"
                                               v-model="newCrew.last_name"
                                               placeholder="CREW LAST NAME"
                                        >
                                        <span class="help-block text-danger" v-if="newCrewErrors.last_name">
                                            <small><strong>{{ newCrewErrors.last_name }} </strong></small>
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group row" :class="{ 'has-error': newCrewErrors.last_name }">
                                    <label for="firstName" class="col-sm-4 col-form-label text-lg-right">First Name</label>
                                    <div class="col-sm-7 text-center">
                                        <input type="text" class="form-control form-control-xs"
                                               id="firstName"
                                               v-model="newCrew.first_name"
                                               required
                                               placeholder="CREW FIRST NAME"
                                        >
                                        <span class="help-block text-danger" v-if="newCrewErrors.first_name">
                                            <small><strong>{{ newCrewErrors.first_name }} </strong></small>
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group row" :class="{ 'has-error': newCrewErrors.middle_name }">
                                    <label for="middleName" class="col-sm-4 col-form-label text-lg-right">Middle Name</label>
                                    <div class="col-sm-7 text-center">
                                        <input type="text" class="form-control form-control-xs "
                                               id="middleName"
                                               v-model="newCrew.middle_name"
                                               placeholder="CREW MIDDLE NAME"
                                        >
                                        <span class="help-block text-danger" v-if="newCrewErrors.middle_name">
                                            <small><strong>{{ newCrewErrors.middle_name }} </strong></small>
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group row" :class="{ 'has-error': newCrewErrors.extension }">
                                    <label for="suffix" class="col-sm-4 col-form-label text-lg-right">Suffix</label>
                                    <div class="col-sm-7 text-center">
                                        <select class="form-control form-control-xs custom-select" id="suffix" v-model="newCrew.extension">
                                            <option :value="''">--- Suffix ---</option>
                                            <option :value="nameExtension" v-for="(nameExtension, index) in nameExtensions" :key="index">
                                                {{ nameExtension }}
                                            </option>
                                        </select>
                                        <span class="help-block text-danger" v-if="newCrewErrors.extension">
                                            <small><strong>{{ newCrewErrors.extension }} </strong></small>
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group row" :class="{ 'has-error': newCrewErrors.nickname }">
                                    <label for="otherName" class="col-sm-4 col-form-label text-lg-right">Other Name</label>
                                    <div class="col-sm-7 text-center">
                                        <input type="text" class="form-control form-control-xs "
                                               id="otherName"
                                               v-model="newCrew.nickname"
                                               placeholder="OTHER NAME / NICK NAME"
                                        >
                                        <span class="help-block text-danger" v-if="newCrewErrors.nickname">
                                            <small><strong>{{ newCrewErrors.nickname }} </strong></small>
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group row" :class="{ 'has-error': newCrewErrors.civil_status_id }">
                                    <label for="civilStatus" class="col-sm-4 col-form-label text-lg-right">Civil Status</label>
                                    <div class="col-sm-7 text-center">
                                        <select class="form-control form-control-xs custom-select" id="civilStatus" required v-model="newCrew.civil_status_id">
                                            <option :value="null">--- Select Civil Status ---</option>
                                            <option :value="civilStatusKey.id" v-for="civilStatusKey in civilStatusKeys" :key="civilStatusKey.id">
                                                {{ civilStatusKey.name }}
                                            </option>
                                        </select>
                                        <span class="help-block text-danger" v-if="newCrewErrors.civil_status_id">
                                            <small><strong>{{ newCrewErrors.civil_status_id }} </strong></small>
                                        </span>
                                    </div>
                                </div>

                            </div>

                            <div class="col col-4 px-0">

                                <div class="form-group row" :class="{ 'has-error': newCrewErrors.birthdate }">
                                    <label for="birthdate" class="col-sm-4 col-form-label text-lg-right">Birthdate</label>
                                    <div class="col-sm-7 text-center">
                                        <input type="date" class="form-control form-control-xs" required
                                               id="birthdate"
                                               v-model="newCrew.birthdate"
                                        >
                                        <span class="help-block text-danger" v-if="newCrewErrors.birthdate">
                                            <small><strong>{{ newCrewErrors.birthdate }} </strong></small>
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="age" class="col-sm-4 col-form-label text-lg-right">Age</label>
                                    <div class="col-sm-7">
                                        <input type="text" class="form-control form-control-xs bg-white form-display" readonly
                                               id="age"
                                               v-model="age"
                                               placeholder="N/A"
                                        >
                                    </div>
                                </div>

                                <div class="form-group row" :class="{ 'has-error': newCrewErrors.birthplace }">
                                    <label for="birthplace" class="col-sm-4 col-form-label text-lg-right">Birthplace</label>
                                    <div class="col-sm-7 text-center">
                                        <input type="text" class="form-control form-control-xs"
                                               id="birthplace"
                                               v-model="newCrew.birthplace"
                                               placeholder="BIRTH PLACE"
                                        >
                                        <span class="help-block text-danger" v-if="newCrewErrors.birthplace">
                                            <small><strong>{{ newCrewErrors.birthplace }} </strong></small>
                                        </span>
                                    </div>
                                </div>


                                <div class="form-group row" :class="{ 'has-error': newCrewErrors.religion_id }">
                                    <label for="religion" class="col-sm-4 col-form-label text-lg-right">Religion</label>
                                    <div class="col-sm-7 text-center">
                                        <select class="form-control form-control-xs custom-select" id="religion" v-model="newCrew.religion_id">
                                            <option :value="null">--- Select Religion ---</option>
                                            <option :value="1" v-for="religionKey in religionKeys" :key="religionKey.id">
                                                {{ religionKey.name }}
                                            </option>
                                        </select>
                                        <span class="help-block text-danger" v-if="newCrewErrors.religion_id">
                                            <small><strong>{{ newCrewErrors.religion_id }} </strong></small>
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group row" :class="{ 'has-error': newCrewErrors.country_id }">
                                    <label for="nationality" class="col-sm-4 col-form-label text-lg-right">Nationality</label>
                                    <div class="col-sm-7 text-center">
                                        <select class="form-control form-control-xs custom-select" id="nationality" required
                                                v-model="newCrew.country_id"
                                        >
                                            <option :value="''">--- Select Nationality ---</option>
                                            <option :value="natlKey.id" v-for="natlKey in natlKeys" :key="natlKey.id">
                                                {{ natlKey.natl }}
                                            </option>
                                        </select>
                                        <span class="help-block text-danger" v-if="newCrewErrors.country_id">
                                            <small><strong>{{ newCrewErrors.country_id }} </strong></small>
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group row" :class="{ 'has-error': newCrewErrors.email }">
                                    <label for="birthplace" class="col-sm-4 col-form-label text-lg-right">Email</label>
                                    <div class="col-sm-7 text-center">
                                        <input type="email" class="form-control form-control-xs"
                                               id="email"
                                               v-model="newCrew.email"
                                               placeholder="EMAIL ADDRESS"
                                        >
                                        <span class="help-block text-danger" v-if="newCrewErrors.email">
                                            <small><strong>{{ newCrewErrors.email }} </strong></small>
                                        </span>
                                    </div>
                                </div>

                            </div>

                            <div class="col col-4 pl-0">

                                <div class="form-group row" :class="{ 'has-error': newCrewErrors.male }">
                                    <label for="gender"  class="col-sm-4 col-form-label text-lg-right">Gender</label>
                                    <div id="gender" class="pt-2 px-3 text-center">
                                        <div class="form-check form-check-inline">
                                            <input class="form-check-input" type="radio" name="male" id="male" :value="1" v-model="newCrew.male">
                                            <label class="form-check-label" for="male">Male</label>
                                        </div>
                                        <div class="form-check form-check-inline">
                                            <input class="form-check-input" type="radio" name="male" id="female" :value="0" v-model="newCrew.male">
                                            <label class="form-check-label" for="female">Female</label>
                                        </div>
                                        <span class="help-block text-danger" v-if="newCrewErrors.male">
                                            <small><strong>{{ newCrewErrors.male }} </strong></small>
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group row" :class="{ 'has-error': newCrewErrors.height }">
                                    <label for="heightFt" class="col-sm-4 col-form-label text-lg-right">Height</label>
                                    <div class="col-sm-7">
                                        <select class="form-control form-control-xs custom-select w-60px" id="heightFt" v-model="heightFt" @change="setHeight">
                                            <option value="4">4</option>
                                            <option value="5">5</option>
                                            <option value="6">6</option>
                                            <option value="7">7</option>
                                        </select>
                                        <span class="mx-3">ft.</span>
                                        <select class="form-control form-control-xs custom-select w-60px" id="heightIn" v-model="heightIn" @change="setHeight">
                                            <option value="0">0</option>
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                            <option value="4">4</option>
                                            <option value="5">5</option>
                                            <option value="6">6</option>
                                            <option value="7">7</option>
                                            <option value="8">8</option>
                                            <option value="9">9</option>
                                        </select>
                                        <span class="mx-3">in.</span>
                                        <span class="help-block text-danger" v-if="newCrewErrors.height">
                                            <small><strong>{{ newCrewErrors.height }} </strong></small>
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group row" :class="{ 'has-error': newCrewErrors.weight }">
                                    <label for="weight" class="col-sm-4 col-form-label text-lg-right">Weight</label>
                                    <div class="col-sm-8 form-inline pr-0 text-center">
                                        <input type="text" class="form-control form-control-xs w-75" id="weight"
                                               v-model="newCrew.weight"
                                               placeholder="WEIGHT IN KG"
                                        >
                                        <span class="w-25 pl-2">kg.</span>
                                        <span class="help-block text-danger" v-if="newCrewErrors.weight">
                                            <small><strong>{{ newCrewErrors.weight }} </strong></small>
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group row" :class="{ 'has-error': newCrewErrors.blood_type }">
                                    <label for="bloodType" class="col-sm-4 col-form-label text-lg-right">Blood Type</label>
                                    <div class="col-sm-7 text-center">
                                        <input type="text" class="form-control form-control-xs "
                                               id="bloodType"
                                               v-model="newCrew.blood_type"
                                               placeholder="BLOOD TYPE"
                                        >
                                        <span class="help-block text-danger" v-if="newCrewErrors.blood_type">
                                            <small><strong>{{ newCrewErrors.blood_type }} </strong></small>
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group row" :class="{ 'has-error': newCrewErrors.hair_color }">
                                    <label for="hairColor" class="col-sm-4 col-form-label text-lg-right">Hair Color</label>
                                    <div class="col-sm-7 text-center">
                                        <input type="text" class="form-control form-control-xs"
                                               id="hairColor"
                                               v-model="newCrew.hair_color"
                                               placeholder="HAIR COLOR"
                                        >
                                        <span class="help-block text-danger" v-if="newCrewErrors.hair_color">
                                            <small><strong>{{ newCrewErrors.hair_color }} </strong></small>
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group row" :class="{ 'has-error': newCrewErrors.eye_color }">
                                    <label for="eyeColor" class="col-sm-4 col-form-label text-lg-right">Eye Color</label>
                                    <div class="col-sm-7 text-center">
                                        <input type="text" class="form-control form-control-xs "
                                               id="eyeColor"
                                               v-model="newCrew.eye_color"
                                               placeholder="EYE COLOR"
                                        >
                                        <span class="help-block text-danger" v-if="newCrewErrors.eye_color">
                                            <small><strong>{{ newCrewErrors.eye_color }} </strong></small>
                                        </span>
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>
                </div>

            </div>


            <div class="col col-12 p-0 mt-3">

                    <div class="row bg-light-gray mb-3">
                        <div class="col col-sm-12">
                            <h6 class="h6 font-weight-bold mt-2 text-left">Crew Information</h6>
                        </div>
                    </div>

                    <div class="row text-small">
                        <div class="col-md-4">
                            <div class="form-group row">
                                <label for="rankType" class="col-sm-4 col-form-label text-lg-right">Crew Type</label>
                                <div class="col-sm-7">
                                    <select class="form-control form-control-xs custom-select" id="rankType" v-model="rankTypeId"
                                            @change="setRankKeys"
                                    >
                                        <option :value="null">--- Select Type ---</option>
                                        <option :value="rankTypeKey.id" v-for="rankTypeKey in rankTypeKeys" :key="rankTypeKey.id">
                                            {{ rankTypeKey.name}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group row">
                                <label for="crewRank" class="col-sm-4 col-form-label text-lg-right">Rank</label>
                                <div class="col-sm-7">
                                    <select class="form-control form-control-xs custom-select" id="crewRank" v-model="newCrew.rank_id" required>
                                        <option :value="''">--- Select Rank ---</option>
                                        <option :value="rank.id" v-for="rank in rankKeys" :key="rank.id">{{ rank.name }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group row">
                                <label for="manning" class="col-sm-4 col-form-label text-lg-right">Manning</label>
                                <div class="col-sm-7">
                                    <select class="form-control form-control-xs custom-select" id="manning" required
                                            v-model="newCrew.manning_id"
                                            :disabled="user.manning_id"
                                    >
                                        <option :value="''">--- Select Manning ---</option>
                                        <option :value="manning.id" v-for="manning in manningKeys" :key="manning.id">
                                            {{ manning.alias }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group row">
                                <label for="dateHired" class="col-sm-4 col-form-label text-lg-right">Date Hired</label>
                                <div class="col-sm-7">
                                    <input type="date" id="dateHired" class="form-control form-control-xs" v-model="newCrew.date_hired">
                                </div>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="form-group row">
                                <label for="scholarType" class="col-sm-4 col-form-label text-lg-right">Scholar Type</label>
                                <div class="col-sm-7">
                                    <select class="form-control form-control-xs custom-select" id="scholarType"
                                            v-model="newCrew.scholarId"
                                    >
                                        <option :value="''">--- Select Scholar Type ---</option>
                                        <option :value="scholarKey.id" v-for="scholarKey in scholarKeys" :key="scholarKey.id">
                                            {{ scholarKey.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-4">
                          <div class="form-group row">
                            <label for="pooling" class="col-sm-4 col-form-label text-lg-right">Pooling</label>
                            <div class="col-sm-7">
                              <select class="form-control form-control-xs custom-select" id="pooling" v-model="pooling">
                                <option :value="0">--- Select Pooling ---</option>
                                <option v-for="poolingKey in poolingKeys" :key="poolingKey.id" :value="poolingKey.id">
                                  {{ poolingKey.name }}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>

                    </div>
                </div>

            <div class="col col-12 p-0 mt-3" v-if="newCrew.addresses.length">
                <div class="row bg-light-gray mb-3">
                    <div class="col col-sm-12 text-left">
                        <h6 class="h6 font-weight-bold mt-2">Address</h6>
                    </div>
                </div>

                <div class="row text-small">
                    <div class="col col-4" v-for="(address, index) in newCrew.addresses" :key="address.address_type_id">

                        <div class="card border-0">
                            <h6 class="font-weight-bolder">{{ addressTypeKeys[index].name | ucWord }} Address</h6>

                            <div class="form-group row">
                                <label :for="'country' + index" class="col-sm-4 col-form-label text-lg-right">Country</label>
                                <div class="col-sm-7">
                                    <select class="form-control form-control-xs custom-select"
                                            :id="'country' + index"
                                            @change="updateRegion"
                                    >
                                        <option :value="null">--- Select Country ---</option>
                                        <option :value="natlKey.id" v-for="natlKey in natlKeys" :key="natlKey.id">
                                            {{ natlKey.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label :for="'region' + index" class="col-sm-4 col-form-label text-lg-right">Region</label>
                                <div class="col-sm-7">
                                    <select class="form-control form-control-xs custom-select"
                                            :id="'region' + index"
                                            v-model="address.region_id"
                                            :disabled="!address.regionSelection.length"
                                            @change="updateCities"
                                    >
                                        <option :value="null">--- Select Region ---</option>
                                        <option :value="region.id" v-for="region in address.regionSelection" :key="region.id">
                                            {{ region.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label :for="'city' + index" class="col-sm-4 col-form-label text-lg-right">City / Province</label>
                                <div class="col-sm-7">
                                    <select class="form-control form-control-xs custom-select"
                                            :id="'city' + index"
                                            v-model="address.city_id"
                                            :disabled="!address.citySelection.length"
                                            @change="verifyAddress"
                                    >
                                        <option :value="null">--- Select City / Province ---</option>
                                        <option :value="cityKey.id" v-for="cityKey in address.citySelection" :key="cityKey.id">
                                            {{ cityKey.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label :for="'address' + index" class="col-sm-4 col-form-label text-lg-right">Address</label>
                                <div class="col-sm-7">
                                <textarea class="form-control text-small"
                                          :id="'address' + index" rows="3"
                                          v-model="address.address"
                                          :required="address.city_id"
                                ></textarea>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>

            </div>


            <div class="col col-6 pr-2">
                <div class="row text-small mt-3" v-if="newCrew.crewContacts.length">

                    <div class="col col-12 mb-3">
                        <div class="row bg-light-gray border-right-2">
                            <div class="col col-sm-12 text-left">
                                <h6 class="h6 font-weight-bold mt-2">Contact Details</h6>
                            </div>
                        </div>
                    </div>

                    <div class="col col-12" v-for="(crewContact, index) in newCrew.crewContacts" :key="crewContact.contact_type_id">

                        <div class="form-group row">
                            <div class="col-4 offset-2 pr-1">
                                <select class="form-control form-control-xs custom-select"
                                        :id="'contactType' + index"
                                        v-model="crewContact.contact_type_id"
                                        :disabled="!contactTypeKeys.length"
                                        title="SELECT CONTACT TYPE"
                                >
                                    <option :value="null">--- Contact Type ---</option>
                                    <option :value="contactTypeKey.id" v-for="contactTypeKey in contactTypeKeys" :key="contactTypeKey.id">
                                        {{ contactTypeKey.name }}
                                    </option>
                                </select>
                            </div>

                            <div class="col col-5 pl-0">
                                <input type="text" class="form-control form-control-xs"
                                       v-model="crewContact.contact"
                                       :placeholder="crewContact.name + ' NUMBER' | toUpper"
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col col-6 pl-2">
                <div class="row text-small mt-3" v-if="languageKeys.length">

                    <div class="col col-12 mb-3">
                        <div class="row bg-light-gray border-left-2">
                            <div class="col col-sm-12 text-left">
                                <h6 class="h6 font-weight-bold mt-2">Language Proficiency</h6>
                            </div>
                        </div>
                    </div>

                    <div class="col col-12">

                        <table class="table table-sm table-hover text-center mr-auto ml-3" style="width: 550px;">
                            <thead>
                            <tr>
                                <td></td>
                                <td>Language</td>
                                <td>Average</td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="languageKey in languageKeys" :key="languageKey.id">
                                <td>
                                    <input class="form-check-input" type="checkbox"
                                           :value="languageKey.id"
                                           :id="'language' + languageKey.id"
                                           :checked="newCrew.crewLanguages.some(crewLanguage => crewLanguage.id === languageKey.id)"
                                           @change="addLanguage"
                                    >
                                </td>
                                <td class="text-left">
                                    {{ languageKey.name }}
                                </td>
                                <td>
                                    <select class="form-control form-control-xs custom-select"
                                            :id="'efficiency' + languageKey.id"
                                            v-if="newCrew.crewLanguages.some(crewLanguage => crewLanguage.id === languageKey.id)"
                                            @change="setLanguageEfficiency(languageKey.id)"
                                    >
                                        <option :value="null">--- Select Efficiency ---</option>
                                        <option :value="efficiencyKey.id" v-for="efficiencyKey in efficiencyKeys" :key="efficiencyKey.id">
                                            {{ efficiencyKey.name}}
                                        </option>
                                    </select>
                                </td>
                            </tr>
                            </tbody>
                        </table>

                    </div>
                </div>
            </div>

            <div class="col-12 text-left p-0" v-if="newCrew.agencyNumbers.length">
                <div class="row bg-light-gray mb-3">
                    <div class="col col-sm-12">
                        <h6 class="h6 font-weight-bold mt-2 text-left">Benefits and Contribution</h6>
                    </div>
                </div>

                <div class="row text-small">

                    <div class="col-md-4" v-for="agencyNumber in newCrew.agencyNumbers" :key="agencyNumber.id">
                        <div class="form-group row">
                            <label :for="'agencyNumber' + agencyNumber.id" class="col-sm-5 col-form-label text-lg-right">{{ agencyNumber.name }}:</label>
                            <div class="col-sm-7">
                                <input type="text" class="form-control form-control-xs " :id="'agencyNumber' + agencyNumber.id" v-model="agencyNumber.number">
                            </div>
                        </div>
                    </div>

                </div>
            </div>

<!--            <div class="col-12 text-left p-0">-->
<!--                <div class="row bg-light-gray mb-3">-->
<!--                    <div class="col col-sm-12">-->
<!--                        <h6 class="h6 font-weight-bold mt-2 text-left">Documents</h6>-->
<!--                    </div>-->
<!--                </div>-->
<!---->
<!--                <div class="row text-small">-->
<!--                    <div class="col-md-4">-->
<!--                        <div class="form-group row">-->
<!--                            <label for="biodata" class="col-sm-4 col-form-label text-lg-right">Biodata</label>-->
<!--                            <div class="col-sm-7">-->
<!--                                <div class="custom-file">-->
<!--                                    <input type="file" class="custom-file-input" id="biodata" accept="application/pdf">-->
<!--                                    <label class="custom-file-label" for="biodata">Choose file</label>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="col-md-6">-->
<!--                        <div class="form-group row">-->
<!--                            <label for="consent" class="col-sm-3 col-form-label text-lg-right">Consent Document</label>-->
<!--                            <div class="col-sm-5">-->
<!--                                <div class="custom-file">-->
<!--                                    <input type="file" class="custom-file-input" id="consent" accept="application/pdf">-->
<!--                                    <label class="custom-file-label" for="consent">Choose file</label>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->

        </form>
    </div>
</template>

<script>

    import { mapGetters, mapActions } from 'vuex';
    import {vueAppMixin} from "../../../../mixins/vueAppMixin";
    import {dataMixin} from "../../../../mixins/dataMixin";
    import {CrewService} from "../../../../services/CrewService";

    export default {
        name: "AddCrew",
        mixins: [ vueAppMixin, dataMixin ],

        data() {
            return {
                newCrew: {
                    rank_id: '',
                    civil_status_id: null,
                    country_id: '',
                    date_hired: '',
                    religion_id: null,
                    manning_id: '',
                    first_name: '',
                    middle_name: '',
                    last_name: '',
                    extension: '',
                    nickname: '',
                    male: 1,
                    birthdate: '',
                    birthplace: '',
                    hair_color: '',
                    eye_color: '',
                    blood_type: '',
                    height: '',
                    weight: '',
                    email: '',
                    scholarId: '',
                    crewLanguages: [],
                    agencyNumbers: [],
                    addresses: [],
                    crewContacts: [],
                },
                newCrewErrors: {},
                rankTypeId: 1,
                heightFt: 5,
                heightIn: 0,
                crewImage: require(`@/assets/no_photo.png`),
                pooling: 0
            }
        },

        methods: {
            ...mapActions([
                'getManningKeys',
                'getRankKeys',
                'getNatlKeys',
                'getRankTypeKeys',
                'getCivilStatusKeys',
                'getNatlKeys',
                'getReligionKeys',
                'getLanguageKeys',
                'getEfficiencyKeys',
                'getAgencyKeys',
                'getManningKeys',
                'getAddressTypeKeys',
                'getCityKeys',
                'getRegionKeys',
                'getContactTypeKeys',
                'getScholarKeys',
                'addCrewRecord',
                'updateCrewConsent',
                'updateCrewBiodata',
                'updateCrewImage',
                'verifyCrewExistence',
                'getPoolingKeys'
            ]),

            setRankKeys() {
                this.getRankKeys({ rank_type_id: this.rankTypeId});
                this.newCrew.rank_id = ''
            },

            setHeight() {
                this.newCrew.height = `${this.heightFt} ft. ${this.heightIn}"`;
            },

            addLanguage(e) {
                if(e.target.checked) {
                    let language = this.languageKeys.find(language => language.id == e.target.value);
                    this.newCrew.crewLanguages.push({
                        id: language.id,
                        name: language.name,
                        efficiency_id: null
                    });
                } else {
                    this.newCrew.crewLanguages = this.newCrew.crewLanguages.filter(language => language.id != e.target.value);
                }
            },

            removeLanguage(languageId) {
                this.newCrew.crewLanguages = this.newCrew.crewLanguages.filter(language => language.id != languageId);
            },

            async test() {
                let result = await this.existingCrewAlert();
            },

            async checkDuplicateCrew () {
              let lastNameInput  = document.getElementById('lastName').value;
              let firstNameInput  = document.getElementById('firstName').value;
              let birthdayInput  = document.getElementById('birthdate').value;

              if (!lastNameInput || !firstNameInput || !birthdayInput){
                this.errorAlert('ALL COLORED INPUT BOX IS REQUIRED'
                    ,'CHECK CREW DUPLICATE');
              } else {
                let existingCrews = await this.verifyCrewExistence({
                  last_name: this.newCrew.last_name,
                  first_name: this.newCrew.first_name,
                  birthdate: this.newCrew.birthdate,
                });
                if(existingCrews) {
                  let result = await this.existingCrewAlert(existingCrews);
                  if(!result.value) return null;
                } else {
                  this.noDuplicateAlert();
                }
              }
            },
            async confirmSaveCrewRecord() {

                if(await this.confirmCreateAlert()) {

                    let existingCrews = await this.verifyCrewExistence({
                      last_name: this.newCrew.last_name,
                      first_name: this.newCrew.first_name,
                      birthdate: this.newCrew.birthdate,
                    });

                    if(existingCrews) {
                      let result = await this.existingCrewAlert(existingCrews);
                      if(!result.value) return null;
                    }


                    let newCrewId = await this.addCrewRecord(this.newCrew);
                    if(newCrewId.errors) {
                        this.newCrewErrors = newCrewId.errors;
                    } else {
                        let input = document.getElementById('consent');
                        if (input.files && input.files[0]) {
                            let file = input.files[0];
                            let formData = new FormData();
                            formData.append('crewId', newCrewId.crewId);
                            formData.append('crewConsent', file);
                            await this.updateCrewConsent(formData);
                        }

                        let bioDataInput = document.getElementById('consent');
                        if (bioDataInput.files && bioDataInput.files[0]) {
                            let bioDataFile = bioDataInput.files[0];
                            let bioDataFormData = new FormData();
                            bioDataFormData.append('crewId', newCrewId.crewId);
                            bioDataFormData.append('biodata', bioDataFile);
                            await this.updateCrewBiodata(bioDataFormData);
                        }

                        let crewImageInput = document.getElementById('crewImageInput');
                        if (crewImageInput.files && crewImageInput.files[0]) {
                            let crewImageFile = crewImageInput.files[0];
                            let crewImageData = new FormData();
                            crewImageData.append('crewId', newCrewId.crewId);
                            crewImageData.append('crewImage', crewImageFile);
                            await this.updateCrewImage(crewImageData);
                        }

                        this.successAlert('Crew Record Successfully Added', 'CREATE');
                        this.$router.push({ name: 'CrewPersonal', params: { id: newCrewId.crewId }});
                    }
                }

            },

            clickCrewImageInput() {
                document.getElementById('crewImageInput').click();
            },

            updateImageDisplay() {
                let input = document.getElementById('crewImageInput');
                let crewImage = document.getElementById('crewImage');
                if (input.files && input.files[0]) {
                    if(input.files[0].size > 1000000) {
                        crewImage.alt = 'FILE TOO LARGE';
                        this.clearDisplayImage();
                        return;
                    } else {
                        crewImage.alt = 'CREW IMAGE';
                        let reader = new FileReader();
                        reader.onload = function (e) {
                            crewImage.src  = e.target.result;
                        };
                        reader.readAsDataURL(input.files[0]);
                    }
                } else {
                    this.clearDisplayImage();
                }
            },

            clearDisplayImage() {
                let crewImage = document.getElementById('crewImage');
                crewImage.src  = '';
                crewImage.alt = 'Please Select Crew Image';
            },

            async initializeData() {
                await this.getAddressTypeKeys();
                this.addressTypeKeys.forEach(addressTypeKey => {
                    this.newCrew.addresses.push({
                        address_type_id: addressTypeKey.id,
                        region_id: null,
                        city_id: null,
                        address: '',
                        active: 1,
                        crew_id: null,
                        regionSelection: [],
                        citySelection: [],
                    });
                });

                let contactTypeKeys = await this.getContactTypeKeys();
                contactTypeKeys.forEach(contactTypeKey => {
                    this.newCrew.crewContacts.push({
                        contact: '',
                        contact_type_id: contactTypeKey.id,
                        name: contactTypeKey.name,
                    });
                });

                await this.getLanguageKeys();
                await this.getEfficiencyKeys();

                await this.getManningKeys();
                if(this.user.manning_id) {
                    this.newCrew.manning_id = this.user.manning_id;
                    this.newCrew.country_id = this.manningKeys.find(manning => manning.id == this.user.manning_id).country_id
                }
                await this.getAgencyKeys();
                this.agencyKeys.forEach(agencyKey => {
                    this.newCrew.agencyNumbers.push({
                        id: agencyKey.id,
                        name: agencyKey.name,
                        number: '',
                    });
                })
                this.setHeight();
                await this.getRankTypeKeys();
                await this.getRankKeys({ rank_type_id: 1 });
                await this.getNatlKeys();
                await this.getCivilStatusKeys();
                await this.getReligionKeys();
                await this.getScholarKeys();

            },

            async updateRegion(event) {
                let regions = await this.getRegionKeys(event.target.value);
                let id = event.target.id;
                let index = id.substring('country'.length);
                this.newCrew.addresses[index].regionSelection = regions;

                this.newCrew.addresses[index].region_id = null
                this.newCrew.addresses[index].citySelection = []
                this.newCrew.addresses[index].city_id = null
            },

            async updateCities(event) {
                let cities = await this.getCityKeys(event.target.value);
                let id = event.target.id;
                let index = id.substring('region'.length);
                this.newCrew.addresses[index].citySelection = cities;
            },

            verifyAddress(event) {
                if(!event.target.value) {
                    let id = event.target.id;
                    let index = id.substring('city'.length);
                    this.newCrew.addresses[index].address = '';
                }
            },

            setLanguageEfficiency(languageId) {
                let select = document.getElementById('efficiency' + languageId);
                this.newCrew.crewLanguages.find(language => {
                    return language.id == languageId
                }).efficiency_id = select.value;
            }
        },

        created() {
            this.initializeData();
            this.getPoolingKeys();
        },

        computed: {
            ...mapGetters([
                'manningKeys',
                'rankKeys',
                'natlKeys',
                'poolingKeys',
                'manningId',
                'poolingKeys',
                'rankTypeKeys',
                'nameExtensions',
                'civilStatusKeys',
                'natlKeys',
                'religionKeys',
                'languageKeys',
                'efficiencyKeys',
                'agencyKeys',
                'manningKeys',
                'addressTypeKeys',
                'cityKeys',
                'regionKeys',
                'contactTypeKeys',
                'scholarKeys',
                'user'
            ]),
            age() {
                if(!this.newCrew.birthdate) return '';
                let age = 0;
                let dateNow = new Date();
                let birthday = new Date(this.newCrew.birthdate);
                age = dateNow.getFullYear() - birthday.getFullYear();
                let m = dateNow.getMonth() - birthday.getMonth();
                if (m < 0 || (m === 0 && dateNow.getDate() < birthday.getDate())) {
                    age--;
                }
                return age + ' years old';
            },

        }
    }
</script>

<style scoped>
.crew-pic-container {
    text-align: center;
    margin-bottom: 10px;
    width: 192px;
    height: 192px;
}
.crew-pic {
    width: 100px;
    height: auto;
}

.crew-pic:hover {
    border: 1px solid black;
}

input:required:empty {
    border: 1px solid red;
}

select:required:empty {
    border: 1px solid red;
}

.bg-light-gray {
    background-color: #F0F0F0;
}

.border-left-2 {
    border-left: 2px solid #dee2e6 !important;
}

.border-right-2 {
    border-right: 2px solid #dee2e6 !important;
}
.w-60px {
  max-width: 50px;
}
</style>
